import loggedoutView from './headerLoggedoutView.html';

export default function loggedoutComponent() {
	return {
		restrict: 'E',
		scope: {},
		bindToController: {},
		controllerAs: 'vm',
		controller: loggedoutComponentCtrl,
		template: loggedoutView,
	};
}

class loggedoutComponentCtrl {
	constructor($window) {
		'ngInject';
	}
}
